import { createReducer } from '@reduxjs/toolkit';

import { FetchStatus } from '../../enums';
import * as actions from './actions';
import { IAppState } from './types';

export const initialState: IAppState = {
  status: FetchStatus.IDLE,
};

export const appReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(actions.resetAppStatus, (state) => {
      state.status = FetchStatus.IDLE;
    })
    .addCase(actions.sendEmail, (state) => {
      state.status = FetchStatus.LOADING;
    })
    .addCase(actions.sendEmailSucceeded, (state) => {
      state.status = FetchStatus.SUCCESS;
    })
    .addCase(actions.sendEmailFailed, (state) => {
      state.status = FetchStatus.FAILURE;
    });
});
